import * as React from "react";

import { Image } from "antd";

const CommentImagePreviewGroup = ({ imageList, onDeleteImage, loading }) => {
	return (
		<Image.PreviewGroup>
			<div
				className={`comment-image-preview-group`}
				style={imageList?.length ? { marginTop: "0.5em" } : {}}
			>
				{imageList?.map((src, idx) => (
					<div className={`image-div`} key={`image-comment-images-key-${idx}`}>
						<Image
							preview={{
								mask: <></>,
							}}
							src={src}
							alt={`상담 글 이미지 ${idx}`}
						/>
						<img
							src={`/assets/images/channel/cancel.png`}
							alt={`이미지 삭제`}
							className={`image-delete-icon`}
							onClick={() => {
								if (!loading) {
									onDeleteImage(idx);
								}
							}}
						/>
					</div>
				))}
			</div>
		</Image.PreviewGroup>
	);
};

export default CommentImagePreviewGroup;
